import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'core-table-sorter',
  templateUrl: './table-sorter.component.html',
  styleUrls: ['./table-sorter.component.css']
})

export class TableSorterComponent implements OnInit {

 
  @Input()
  public isSorted: boolean;
  @Input()
  public isDescending: boolean;

  constructor() { 
    
  }

  ngOnInit() {
  }


}